<template>
    <div class="page">
        <div class="page-text-wrap">
            <h1>Kræmmerne</h1>
            <img class="img-responsive" src="@/assets/info/marked.jpg" />
            <p>Et Vorbasse Marked uden kræmmere et ikke et rigtigt Vorbasse Marked. 650 kræmmere og smådyrshandlende har vi på plads, når markedet afholdes på markedspladsen i Vorbasse. Her handles med alt mellem himmel og jord. Nok skal man lede lidt, men vi tror, at langt det meste vil kunne findes på Vorbasse Marked.</p>
            <p>Vi har omkring km "vej", så skal du besøge alle kræmmere, er det en tur på ca 10 km.</p>
        </div>
    </div>
</template>

<script>
	export default {
		name: "Kraemmerne.vue"
	}
</script>
